// SHARED UTILS WITH BUILDING PAGE SSR AND MAIN APP
import { Publisher } from "./../../pubsub/publisher.js";

export const _scrollID = (id, offset) => {
  var el = null;
  el = document.getElementById(id);
  if (offset === undefined) {
    offset = 0;
  }

  if (el === undefined || !el || el === null) {
    el = document.getElementsByClassName(id);
    if (el.length <= 0) {
      return false; // window.scrollTo(0, 0);
    } else {
      el = el[0];
    }
  }

  function findPos(obj) {
    var curtop = 0;
    if (obj.offsetParent) {
      do {
        curtop += obj.offsetTop;
      } while ((obj = obj.offsetParent));
      return [curtop];
    }
  }
  var scrollTo = function(to, duration) {
    var element = document.scrollingElement || document.documentElement,
      start = element.scrollTop,
      change = to - start,
      startDate = +new Date(),
      easeInOutQuad = function(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      },
      animateScroll = function() {
        const currentDate = +new Date();
        const currentTime = currentDate - startDate;
        element.scrollTop = parseInt(
          easeInOutQuad(currentTime, start, change, duration)
        );
        if (currentTime < duration) {
          requestAnimationFrame(animateScroll);
        } else {
          element.scrollTop = to;
        }
      };
    animateScroll();
  };

  var yScroll = findPos(el);
  yScroll = parseInt(yScroll) + parseInt(offset);
  //console.log(yScroll);
  scrollTo(yScroll, 200);
  //window.scrollTo(0, yScroll - 70);
};

export const _nameToUrl = (name, type) => {
  if(!name) {return;}
  name = name.toLowerCase().trim();
  if (name.includes("co-op") && (!type || type !== "company")) {
    name = name.replace(/-/g, "");
  }

  //turns ' into %27 for urls
  name = name.replace(/\'/g, '%27')
  // console.log('name after %27 replace', name)
  
  // replaces all non-word chars - need to keep % for ' uri encoding
  return name.replace(/[^a-zA-Z0-9%_]+/g, "-");
  // return name.replace(/\W+/g, "-");
};

//TO DO ONCE WE KNOW WHAT WE WANT DONE WITH CO-OP, COOP, AND OTHER EDGE CASES
export const _urlToName = url => {
  const namesWithPunctuation = {
    "astoria-ditmars": "astoria-ditmars",
    "co-op-city": "co-op city",
    "douglaston-little-neck": "douglaston-little neck",
    "holliswood-terrace-heights": "holliswood-terrace heights",
    "travis-chelsea": "travis-chelsea",
    "st-george": "st. george",
  };

  if (!url) return "";
  url = url.toLowerCase().trim();

  if(
      (url.includes("coop") && !url.includes("cooper")) || url.includes("co-op-")
    ) {
    return (url = url
      .replace(/-/g, " ")
      .replace(/(coop)/g, "co-op")
      .replace(/(co\sop)/g, "co-op"));
  } else if (url.includes("co-op")) {
    return url;
  } else if(namesWithPunctuation[url]) {
    return namesWithPunctuation[url];
  } else {
    url = url.replace(/%27/g, "'");
    return url.replace(/-/g, " ");
  }

  // return url.replace(/-/g, ' ');
};

export const _capitalizeText = str => {
  // console.log('_capitalizeText', str)
  if (!str) return "";

  var text = str.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  }).replace(/-\w/, function(txt){return txt.toUpperCase()});
  text = text
    .replace("&Amp;", " & ")
    .replace("Cbs", "CBS")
    .replace("Co Op", "Co-op")
    .replace("Co-Op", "Co-op")
    .replace("Co-op-", "Co-op ")
    .replace(/Coop\b/, "Co-op ")
    .replace("Public-Facilities", "Public Facilities")
    .replace("Cps", "CPS")
    .replace("crg", "CRG")
    .replace("Crg", "CRG")
    .replace("Dsa", "DSA")
    .replace(/^Elliman/, "Douglas Elliman Real Estate")
    .replace("Evgb", "EVGB")
    .replace("Gpb", "GPB")
    .replace("Gph", "GPH")
    .replace("Gp", "GP")
    .replace("Gst", "GST")
    .replace("Hfz", "HFZ")
    .replace("Hsbc", "HSBC")
    .replace("Iii", "III")
    .replace(/Ii\b/, "II")
    .replace("Jfk", "JFK")
    .replace("Jp", "JP")
    .replace("Kwnyc", "KWNYC")
    // .replace("Lic", "LIC")
    .replace(/ lic(?![A-Za-z])/gi, " LIC")
    // .replace("Llc", "LLC")
    .replace(/ llc(?![A-Za-z])/gi, " LLC")
    .replace("Llp", "LLP")
    .replace("Lllp", "LLLP")
    .replace("Lml", "LML")
    .replace("Lp", "LP")
    .replace("Ltf", "LTF")
    .replace("Ltd", "LTD")
    .replace("ltd", " LTD")
    .replace(/Multi\s?Family/gi, "Multi-Family")
    .replace("Mns", "MNS")
    .replace("Mtl", "MTL")
    .replace(/\b,\s?N.?a.?,?\b/, "")
    .replace("Nbo4", "NBO4")
    .replace("Nyc", "NYC")
    .replace("NYCha", "NYCHA")
    .replace("Nys", "NYS")
    .replace("Ny", "NY")
    .replace("-Op", "-op")
    .replace("Pc", "PC")
    .replace("P.c", "P.C")
    .replace("Pllc", "PLLC")
    .replace("Pnc", "PNC")
    .replace("P.s", "P.S")
    .replace(" Pss ", " PSS ")
    .replace(/, Ra\b/, ", RA")
    .replace("Rca", "RCA")
    .replace("Rktb", "RKTB")
    .replace("Rkt&b", "RKT&B")
    .replace("Singlefamily", "Single Family")
    .replace("Stv", "STV")
    .replace("Tf", "TF")
    .replace("The Xi", "The XI")
    .replace("Usa", "USA")
    .replace("U.s.a", "U.S.A")
    .replace("Ymca", "YMCA");

  return text;
};

//validate data link
export const _validateLink = link => {
  let cleanedLink;

  if (!link.includes("http")) {
    cleanedLink = "http://" + Array.isArray(link) ? link[0] : link;
  } else if (!link) {
    cleanedLink = false;
  } else if (Array.isArray(link)) {
    cleanedLink = link[0];
  } else if (link.includes(",")) {
    cleanedLink = link.slice(0, link.indexOf(","));
  } else {
    cleanedLink = link;
  }

  // console.log(cleanedLink);
  return cleanedLink;
};

export const _chunkArray = (arr, size) => {
  if (!Array.isArray(arr) || arr.length === 0) {
    throw new TypeError("_chunkArray Input should be Array longer than 0");
  }

  if (typeof size !== "number") {
    throw new TypeError("_chunkArray Size should be a Number");
  }

  // if(arr.length === 0) {return arr;}

  let tempArray = [];

  for (let i = 0, j = arr.length; i < j; i += size) {
    let myChunk = arr.slice(i, i + size);
    tempArray.push(myChunk);
  }

  return tempArray;
};

export const _shuffleArray = array => {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }

  return array;
};

export const _shouldShow = (data, only) => {
  // console.log("_shouldShow data", data, "only", only)
  var should_show = false;

  if (typeof data === "string") data = data.trim();
  // if (Array.isArray(data)) {
  //   const filteredData = data.filter(el => (el !== undefined && el !== null && el != "" && el !== -1 && el !== 0 && el != "null"));
  //   should_show = filteredData.length > 0;
  // }

  if (
    data !== undefined &&
    data !== null &&
    data != "" &&
    data !== -1 &&
    data !== 0 &&
    data != "null"
  ) {
    should_show = true;
  }
  if (only !== undefined && Array.isArray(only) && !only.indexOf(data) >= 0) {
    should_show = false;
  }

  return should_show;
};

//IS DATA EQUAL
export const _isEqual = (a, b, key) => {
  // Create arrays of property names
  // If number of properties is different,
  // objects are not equivalent
  if (a === undefined || b === undefined) {
    if (a === b) {
      return true;
    } else {
      return false;
    }
  }
  if (a.length != b.length) {
    return false;
  }

  if (Array.isArray(a[key]) && Array.isArray(b[key])) {
    if (a[key].length !== b[key].length) {
      return false;
    }
  }

  for (var i = 0; i < a.length; i++) {
    var item_a = a[i];
    var item_b = b[i];

    if (key && (Array.isArray(item_a[key])) || Array.isArray(item_b[key])) {
      // if(
      //   (!Array.isArray(item_a[key])) || !Array.isArray(item_b[key])
      //   ||
      //   (!Array.isArray(item_a[key])) || !Array.isArray(item_b[key])
      // ) {
      //   return false;
      // }
      if (!_isEqual(item_a[key], item_b[key])) return false;
    } else if (key && item_a[key] !== item_b[key]) {
      return false;
    } else if (key === undefined && item_a !== item_b) {
      return false;
    }
  }

  return true;
};

//random google map api key
export const _generateRandomAPI = arr => {
	if(!arr) {return}
  let apiIndex = Math.floor(Math.random() * arr.length);
  return apiIndex;
};

export const _shouldShowBuildingPhoto = (pic) => {
  // console.log("_shouldShowBuildingPhoto pic", pic, _shouldShow(pic))
  if(!_shouldShow(pic)){return false};

  let show = false;
  if(!pic.includes('bellmarc') && !pic.includes('olr') && !pic.includes('usp=sharing')) {
    show = true;
  }

  return show;
}

export const _hasMPImgUpload = (picsArr) => {
  // checking for all pass versions of image uploads - MARKETPROOF, WE3-BUILDINGS/BUILDING, drive.google, we3-news
  let hasMPImg = picsArr.filter(image => (image.indexOf('MARKETPROOF') > -1 || image.indexOf("drive.google") > -1 || image.indexOf('WE3-BUILDINGS/BUILDING') > -1 || image.indexOf("we3-news") > -1) && _shouldShowBuildingPhoto(image) < 0 && image.toLowerCase().indexOf('!') < 0) && 
    picsArr.filter(image => (
      (
        image.indexOf('MARKETPROOF') > -1 ||
        image.indexOf("drive.google") > -1 ||
        image.indexOf('WE3-BUILDINGS/BUILDING') > -1
      ) && 
      _shouldShowBuildingPhoto(image) && 
      image.toLowerCase().indexOf('!') < 0)).length > 0;

  console.log('hasMPImg', hasMPImg)
  return hasMPImg;
}

export const _makeBuildingPhotosArr = (building, gApiKey = "key=AIzaSyBPfa0KmEt3mpJLZLI8JXTXS78G7NFLGoA") => {
  const filteredbuildingPictures = building && building.pictures && building.pictures.length > 0 && _shouldShow(building.pictures)
    ? building.pictures.filter(el => _shouldShow(el) && _shouldShowBuildingPhoto(el)).map(pic => pic.replace("http://", "https://"))
    : false;

  console.log("_makeBuildingPhotosArr filteredbuildingPictures", filteredbuildingPictures)

  let photoArr = filteredbuildingPictures
    ? building.image &&
      _shouldShow(building.image) &&
      _shouldShowBuildingPhoto(building.image)
      ? [...filteredbuildingPictures, building.image.replace("http://", "https://")]
      : filteredbuildingPictures
    : building.image &&
      _shouldShow(building.image) &&
      _shouldShowBuildingPhoto(building.image)
      ? [building.image.replace("http://", "https://")]
      : _getBuildingPhotos(building, gApiKey);
  
  console.log('_makeBuildingPhotosArr photoArr', photoArr)
  return photoArr;
}

export const _getMarketProofImg = (picsArr, singleImg = false) => {
  console.log("_getMarketProofImg picsArr", picsArr, 'singleImg', singleImg)
  if(!picsArr || 
      (picsArr && picsArr.length === 0) || 
      (picsArr && picsArr.filter(pic => pic && _shouldShow(pic)) && 
        picsArr.filter(pic => pic && _shouldShow(pic) && _shouldShowBuildingPhoto(pic)).length < 1
      ) 
    ) 
  {
    console.log("returning empty arr")  
    return []
  };
  
  if(!_hasMPImgUpload(picsArr)) { 
    console.log('no mp img returning picsArr[0]', picsArr[0])
    return singleImg 
      ? _shouldShow(picsArr[0]) && _shouldShowBuildingPhoto(picsArr[0])
        ? [picsArr[0]]
        : []
      : picsArr.filter(pic => pic && _shouldShow(pic) && _shouldShowBuildingPhoto(pic)).slice(0,3);
  
  } else {
    const chosenPicsArr = [];
    const picsStr = picsArr.join('');
    // console.log("has mpImage")
    if(picsStr.includes('MARKETPROOF')) {
      // cached image on back end - need to reverse the order to get the most recent
      console.log("MARKETPROOF", [picsArr.filter(image => image.indexOf('MARKETPROOF') > -1 && image.toLowerCase().indexOf('!')<0)[0]])
      singleImg
        ? chosenPicsArr.push(picsArr.filter(image => image.indexOf('MARKETPROOF') > -1 && image.toLowerCase().indexOf('!')<0).slice(-1).pop())
        : chosenPicsArr.push(...picsArr.filter(image => image.indexOf('MARKETPROOF') > -1 && image.toLowerCase().indexOf('!')<0).reverse());
      if(singleImg) return chosenPicsArr;
    } 

    if(picsStr.includes("we3-news")) {
      console.log("we3-news/building.image", [picsArr.filter(image => image.indexOf('we3-news') > -1 && image.toLowerCase().indexOf('!')<0)[0]])
      singleImg
        ? chosenPicsArr.push(picsArr.filter(image => image.indexOf('we3-news') > -1 && image.toLowerCase().indexOf('!')<0)[0].trim())
        : chosenPicsArr.push(...picsArr.filter(image => image.indexOf('we3-news') > -1 && image.toLowerCase().indexOf('!')<0));
      if(singleImg) return chosenPicsArr;
    } 

    if(picsStr.includes("drive.google") || picsStr.includes("WE3-BUILDINGS/BUILDING")) {
      console.log("drive or WE3_BUILDINGS and NO usp=sharing", 
        picsArr.filter(image => ((image.indexOf("drive.google") > -1 || image.indexOf('WE3-BUILDINGS/BUILDING') > -1) && image.indexOf("usp=sharing") < 0) && image.toLowerCase().indexOf('!')<0)
      )
      singleImg
        ? picsArr.filter(image => ((image.indexOf("drive.google") > -1 || image.indexOf('WE3-BUILDINGS/BUILDING') > -1) && _shouldShowBuildingPhoto(image)) && image.toLowerCase().indexOf('!') < 0).length > 0 
          ? chosenPicsArr.push(picsArr.filter(image => ((image.indexOf("drive.google") > -1 || image.indexOf('WE3-BUILDINGS/BUILDING') > -1) && _shouldShowBuildingPhoto(image)) && image.toLowerCase().indexOf('!') < 0)[0])
          : []
        : chosenPicsArr.push(...picsArr.filter(image => ((image.indexOf("drive.google") > -1 || image.indexOf('WE3-BUILDINGS/BUILDING') > -1) && _shouldShowBuildingPhoto(image)) && image.toLowerCase().indexOf('!') <0 ));  
      if(singleImg) return chosenPicsArr;
    }

    console.log("_getMarketProofImg chosenPicsArr", chosenPicsArr);
    return chosenPicsArr.slice(0,3);
  }
}

// not using now bc a lot of the backend cache photos show up blank - use 
// const imgArr = _makeBuildingPhotosArr(buildingRes, gApiKey);
// buildingImages = _getMarketProofImg(imgArr);
export const _getBuildingPhotos = function(building, gApiKey, url = false) {
  console.log('_getBuildingPhotos building', building, 'gApiKey', gApiKey, 'url', url)
  var buildingImages = [];
  var address = building.display_full_street_address
    ? building.display_full_street_address
    : building.full_street_address;

  const hood = building.city
    ? building.city
    : building.neighborhood
    ? Array.isArray(building.neighborhood) && building.neighborhood.length > 0
      ? building.neighborhood[0]
      : building.neighborhood
    : false;

  var defaultImage =
    "https://maps.googleapis.com/maps/api/streetview?" +
    gApiKey +
    "&size=700x700&location=" +
    address +
    ", " +
    building.city +
    ", " +
    building.zip +
    "&fov=90&pitch=10&source=outdoor";

  //Shortcut the image processing and use backend cache.
  if(building.pictures && Array.isArray(building.pictures) && _shouldShow(building.pictures)){
    var found = false;
    building.pictures.forEach(image=>{  
      if(image.toLowerCase().indexOf('marketproof')>-1 && image.toLowerCase().indexOf('!')<0){
        buildingImages.push(image);
        found = true;
      }     
     });
     
     if(found) return buildingImages;
   }
  if (process.env.API_URL) {
    defaultImage = process.env.API_URL + "buildings/pictures/" + building.key;
    if(building.key && building.key[0]=="p"){
      defaultImage = process.env.API_URL + "buildings/pictures/" + building.building;
  }
    buildingImages.push(defaultImage);
    return buildingImages;
  }

  if (
    building.image &&
    building.image != "" &&
    building.image.indexOf("olr") < 0 &&
    building.image.indexOf("bellmarc") < 0
  ) {
    buildingImages.push(building.image);
  }

  if (
    building.pictures &&
    building.pictures.length > 0 &&
    buildingImages.length == 0
  ) {
    for (var i = 0; i < building.pictures.length; i++) {
      //check for list of concatenated images - account for error in manual override
      var img = building.pictures[i].split("\n")[0];

      if (img.indexOf("we3-news") >= 0) {
        buildingImages.push(img);
        break;
      }
    }
    if (buildingImages.length == 0) {
      for (var i = 0; i < building.pictures.length; i++) {
        //check for list of concatenated images - account for error in manual override
        var img = building.pictures[i].split("\n")[0];

        if (
          img.indexOf("drive.google") >= 0 &&
          img.indexOf("usp=sharing") < 0 &&
          img != ""
        ) {
          buildingImages.push(img.replace("http://", "https://"));
          break;
        }
      }
    }

    /*Remove images we don't have license to
      if (buildingImages.length == 0) {
        for (var i = 0; i < building.pictures.length; i++) {
          //check for list of concatenated images - account for error in manual override
          var img = building.pictures[i].split('\n')[0];
  
          if (img.indexOf('bellmark') < 0 && img.indexOf('bellmarc') < 0 && img.indexOf('usp=sharing') < 0 && img !='') {
            //buildingImages.push(img);
            break;
          }
        }
        }
*/
  }

  if (buildingImages.length == 0) {
    buildingImages.push(defaultImage);
  }
  return buildingImages;
};

// #STRING MANIPULATIONS
export const _slugifyText = (text) => {
  // console.log('_slugifyText ', text)

  if(!text) return '';
  const sluggedText = text
    .toString()
    .toLowerCase()
    .replace(/\s/g, "-")
    .replace(/_/g, "-") 

  // console.log('_slugifyText ', sluggedText)
  return sluggedText;
}

export const _makeSlugifiedArr = (featureSet) => {
  if(!featureSet) return [];
  const featureArr = Array.isArray(featureSet)
        ? featureSet.filter((el, i, arr) => el && arr.indexOf(el) === i).map(el => _slugifyText(el))
        : [_slugifyText(featureSet)]

  return featureArr;
}

export const _isHouse = (building) => {
  // console.log('_isHouse utils building', building)
  let isHouse = false;
  //  ADD TOWNHOUSE ETC?
  const houseTypeArr = ['single family', 'single-family'];
  if(!building || (building && (!building.ownership_type || !_shouldShow(building.ownership_type)))) {return isHouse;}
  // console.log('_isHouse has ownership_type', houseTypeArr.includes(building.ownership_type.toLowerCase().trim()))
                           
  if(houseTypeArr.includes(building.ownership_type.toLowerCase().trim())) {
    // console.log('_isHouse in houseArr')
    isHouse = true;
  }

  // console.log('_isHouse ', isHouse)
  return isHouse;
}

export const _isCommerical = building => {
  var commercial = false;
  // $land_use_mapping = array(
  //       'residential' => array("01", "02", "03", "04"),
  //       'office-and-retail' => array("05"),
  //       'industrial-and-manufacturing' => array("06"),
  //       'transportation-and-utility' => array("07"),
  //       'public-facilities' => array("08"),
  //       'open-space-and-outdoor-recreation' => array("09"),
  //       'parking-facilities' => array("10"),
  //       'vacant-land' => array("11"),
  //       'hotel-and-timeshare' => array("N/A")       
  //     );
  var commercial_use = ["05", "06", "07", "08", "09", "10", "11"];

  if (building.land_use_category) {
    // console.log('land_use', building.land_use_category, 'age', building.building_age, 'conversion', building.conversion_type);

    if (
      commercial_use.includes(building.land_use_category) &&
      (!building.building_age || 
        (building.building_age &&
      _urlToName(building.building_age) !== "new development")) &&
      (!building.conversion_type ||
        (building.conversion_type &&
      _urlToName(building.conversion_type) !== "new conversion"))
    ) {
      commercial = true;
    }
  }

  if (
    (building.property_category &&
      building.property_category.toLowerCase().trim() == "commercial") ||
    (building.ownership_type &&
      building.ownership_type.toLowerCase().trim() == "commercial")
  ) {
    commercial = true;
  }

  // console.log('_isCommerical ', commercial);
  return commercial;
};

export const _formatBeds = function(property) {
  var beds = "";
  if (!property) {
    return "";
  }

  if (property.bedrooms !== undefined) {
    if (property.bedrooms < 0) {
      beds = "-- Beds";
    } else if (property.bedrooms == 0) {
      beds = "Studio";
    } else if (property.bedrooms == 1) {
      beds = "1 Bed";
    } else {
      beds = property.bedrooms + " Beds";
    }
  }

  return beds;
};

export const _formatBaths = function(property) {
  var baths = "";
  if (!property) {
    return "";
  }

  if (property.baths !== undefined) {
    if (property.baths <= 0) {
      baths = "-- Baths";
    } else if (property.baths == 1) {
      baths = "1 Bath";
    } else {
      baths = property.baths + " Baths";
    }
  }

  return baths;
};

export const _formatListingHeadline = listingHeadline => {
  return listingHeadline
    .replace(/apt|\#/i, "Unit")
    .replace(/, building/i, "")
    .trim();
};

export const _formatNumber = number => {
  if (!number) return;

  return Math.round(number)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const _formatPrice = price => {
  price = ~~price;
  price = Math.abs(price);
  if (price <= 0) {
    return "--";
  }

  if (price.toString().length >= 7) {
    return "$" + (price / 1000000).toFixed(price % 1000000 != 0) + "m";
  }else if (price.toString().length >= 4 && price.toString().length <7 ) {
    return "$" + (price / 1000).toFixed() + "k";
  }

  return "$" + price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const _formatUnitDisplay = unit => {
  return (
    "Unit " +
    unit
      .replace("_", "/")
      .slice(unit.indexOf("-") + 1, unit.length)
      .replace(/-/g, " ")
      .toUpperCase()
      .trim()
  );
};

export const _getFeaturesArr = (type, isHouse, data) => {
  // console.log('_getFeaturesArr type', type, 'isHouse', isHouse,  'data', data)
  let compiledFeatureList = [];
  let featuresData = [];
  let amenitiesData = [];
  
  if(isHouse || type === 'unit') {
    const _appliances = data && _shouldShow(data.property_features_appliances)
      ? _makeSlugifiedArr(data.property_features_appliances)
      : [];

    const _finishes = data && _shouldShow(data.property_features_finishes)
      ? _makeSlugifiedArr(data.property_features_finishes)
      : [];

    const _layout = data && _shouldShow(data.property_features_layout)
      ? _makeSlugifiedArr(data.property_features_layout)
      : [];

    const _exposure = data && _shouldShow(data.property_features_exposure)
      ? _makeSlugifiedArr(data.property_features_exposure)
      : [];

    const _views = data && _shouldShow(data.property_features_views)
      ? _makeSlugifiedArr(data.property_features_views)
      : [];

    const _outdoorSpace = data && _shouldShow(data.property_features_private_outdoor_space)
      ? _makeSlugifiedArr(data.property_features_private_outdoor_space)
      : [];

    const _hvac = data && _shouldShow(data.property_features_hvac)
      ? _makeSlugifiedArr(data.property_features_hvac)
      : []; 

    featuresData = [..._appliances, ..._finishes, ..._layout, ..._exposure, ..._views, ..._outdoorSpace, ..._hvac].filter((item, i, arr) => arr.indexOf(item) === i);
    // console.log("featuresData", featuresData)
  }
  
  if(isHouse || type === 'building') {
    const _autoAmenities = data && _shouldShow(data.amenities_auto)
      ? _makeSlugifiedArr(data.amenities_auto)
      : [];

    const _storageAmenities = data && _shouldShow(data.amenities_building_storage)
      ? _makeSlugifiedArr(data.amenities_building_storage)
      : [];

    const _entertainmentAmenities = data && _shouldShow(data.amenities_entertainment)
      ? _makeSlugifiedArr(data.amenities_entertainment)
      : [];

    const _healthAmenities = data && _shouldShow(data.amenities_health)
      ? _makeSlugifiedArr(data.amenities_health)
      : [];

    const _outdoorSpaceAmenities = data && _shouldShow(data.amenities_outdoor_space)
      ? _makeSlugifiedArr(data.amenities_outdoor_space)
      : [];

    const _buildingAccess = data && _shouldShow(data.building_access)
      ? _makeSlugifiedArr(data.building_access)
      : [];

    const _buildingServiceLevel = data && _shouldShow(data.building_service_level)
      ? _makeSlugifiedArr(data.building_service_level)
      : [];

    const _buildingPolicies = data && _shouldShow(data.building_policies)
      ? _makeSlugifiedArr(data.building_policies)
      : [];

    const _buildingEco = data && _shouldShow(data.amenities_eco)
          ? _makeSlugifiedArr(data.amenities_eco)
          : [];

    const _laundry = data && _shouldShow(data.amenities_laundry)
          ? _makeSlugifiedArr(data.amenities_laundry)
          : [];

    const _commonSpace = data && _shouldShow(data.amenities_common_space)
          ? _makeSlugifiedArr(data.amenities_common_space)
          : [];

    const _buildingTechnology = data && _shouldShow(data.amenities_technology)
          ? _makeSlugifiedArr(data.amenities_technology)
          : [];
    
    amenitiesData = [..._autoAmenities, ..._storageAmenities, ..._entertainmentAmenities, ..._healthAmenities, ..._outdoorSpaceAmenities, ..._buildingAccess, ..._buildingServiceLevel, ..._buildingPolicies, ..._buildingEco, ..._laundry, ..._commonSpace, ..._buildingTechnology].filter((item, i, arr) => arr.indexOf(item) === i);
  }

  if(type == "unit") {
    compiledFeatureList = featuresData;
  } else if(isHouse) {
    compiledFeatureList = [...featuresData, ...amenitiesData];
  } else {
    compiledFeatureList = amenitiesData;
  }

// console.log('featuresData returned ', featuresData)
// console.log('amenitiesData returned ', amenitiesData)
// console.log('compiledFeatureList returned ', compiledFeatureList)
  return compiledFeatureList;
}

export const _getListingDisplayRules = (listing, authData) => {
  // console.log('_getListingDisplayRules called', listing, 'listingData', listingData,);

  const listingData = listing.key
    ? Object.assign({}, listing)
    : listing.data
      ? Object.assign({}, listing.data)
      : false;
  if(!listingData || (listingData && !_shouldShow(listingData.source_namespace))) {return;}
  listingData.source_namespace = Array.isArray(listingData.source_namespace)
    ? listingData.source_namespace
    : [listingData.source_namespace];
  
  // console.log('_getListingDisplayRules past !listingData', listing, 'listingData', listingData,);

  let listingObj = {
    // blur: false,
    // show: true,
  };

  if (listingData.source_namespace.includes('MARKETPROOF-MLSLI')) {
    // console.log('MLSLI')
    /* RULES:
      - only disclaimer for IDX
      - not doing VOW for now - only 3 are VOW only
      - can't show images on old/expired/non-active listings
    */

    listingObj = {
      name: 'MLSLI',
      disclaimer: true,
      isIDX: listingData.is_idx,
      isVOW: false,
      // isVOW: listingData.is_vow,
      showListing: true,
      showUnit: true,
    };
  } else if(listingData.source_namespace.includes('BKMLS')) {
    // console.log('not from REBNY, MLSLI')
    listingObj = {
      name: 'BKMLS',
      disclaimer: true,
      isIDX: true,
      isVOW: false,
      showListing: true,
      showUnit: true,
    };

  // REBNY only  
  } else if(!listingData.source_namespace.includes('REBNY')) {
    // console.log('not from REBNY, MLSLI')
    listingObj = {
      name: listingData.source_namespace[0],
      disclaimer: false,
      isIDX: listingData.is_idx,
      isVOW: listingData.is_vow,
      showListing: true,
      showUnit: true,
    };

  // REBNY only  
  } else {
    // console.log('REBNY listing')
    if(!authData) {return;}
    // if vow needs sign in to show - NOT true if vow AND idx or just idx
    const authNeeded = (authData && 
        authData.authenticated &&
        authData.userData &&
        !authData.userData.vow_verified ||
        (authData && !authData.authenticated)
      ) &&
      ((listingData.is_vow && !listingData.is_idx) || (!listingData.is_vow && !listingData.is_idx));
    const signedIn = authData && authData.authenticated && authData.userData && authData.userData.vow_verified;
    
    /* RULES: 
       - only disclaimer for IDX
      - only show 1 image (no carousel) if VOW and not verified and signed in 
      - can't show images on old/expired/non-active listings
      - can't show unit OR listing if not verified and signed in 
    */
    
    listingObj = {
      name: 'REBNY',
      disclaimer: listingData.is_idx,
      isIDX: listingData.is_idx,
      isVOW: (!listingData.is_idx && !listingData.is_vow) || listingData.is_vow ? true : false,
      numOfImgsToShow: authNeeded ? 1 : false,
      showListing: authNeeded ? signedIn ? true : false : true,
      showUnit: authNeeded ? signedIn ? true : false : true,
      signInRequired: authNeeded,
      signedInForVOW: signedIn,
    };
  }
  
  // console.log('_getListingDisplayRules listingObj.name', listingObj.name, listingObj);
  return listingObj;
}



// pass in the axios.personAxios obj here
export const _getAlgoliaRole = obj => {
  // console.log("_getAlgoliaRole called obj ", obj)
  if(!obj || (obj && Object.keys(obj).length === 0)) {
    return false;
  }

  let role = undefined;
  const compObj = obj.companies 
    ? Array.isArray(obj.companies) && obj.companies.length > 0 && obj.companies[0]
      ? obj.companies[0]
      : obj.companies
        ? obj.companies
        : false
    : false;

  if(compObj) {
    const compTitle = compObj.title 
      ? Array.isArray(compObj.title)
        ? compObj.title[0].toLowerCase().trim()
        : compObj.title.toLowerCase().trim()
      : false;

    const compRole = compObj.role 
      ? Array.isArray(compObj.role)
        ? compObj.role[0].toLowerCase().trim()
        : compObj.role.toLowerCase().trim()
      : false;

    // console.log("compObj ", compObj, "compTitle ", compTitle, "compRole ", compRole);

    role = compTitle
      ? compTitle
      : compRole
        ? compRole
        : obj.title
          ? Array.isArray(obj.title)
            ? obj.title[0].toLowerCase().trim()
            : obj.title.toLowerCase().trim()
          : obj.role
          ? Array.isArray(obj.role)
            ? obj.role[0].toLowerCase().trim()
            : obj.role.toLowerCase().trim()
          : undefined;
  } else {
    role = obj.title
      ? Array.isArray(obj.title)
        ? obj.title[0].toLowerCase().trim()
        : obj.title.toLowerCase().trim()
      : obj.role
      ? Array.isArray(obj.role)
        ? obj.role[0].toLowerCase().trim()
        : obj.role.toLowerCase().trim()
      : undefined;
  }
  
  // FE keys off real estate agent so change if only listing agent available
  if(role === 'listing agent') {
    role = 'real estate agent';
  }
  // props.axios.personAxios.title
  //       ? Array.isArray(props.axios.personAxios.title)
  //         ? props.axios.personAxios.title[0].toLowerCase().trim()
  //         : props.axios.personAxios.title.toLowerCase().trim()
  //       : props.axios.personAxios.role
  //       ? Array.isArray(props.axios.personAxios.role)
  //         ? props.axios.personAxios.role[0].toLowerCase().trim()
  //         : props.axios.personAxios.role.toLowerCase().trim()
  //       : undefined;

  // console.log('_getAlgo role ', role);
  return role;
}

export const _listingPrice = price => {
  if (!price) return;
  if (parseInt(price) <= 0) {
    return "--";
  }
  return (
    "$" +
    Math.round(price)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  );
};

export const _getBuildingAge = (yrBuilt) => {
	if(!yrBuilt) return;
	let age = '';
  // console.log('Date in _getBuildingAge', Date);

	const currentYear = new Date().getFullYear();
	if(yrBuilt > currentYear) {
		age = 'pre-construction';
	} else if(yrBuilt >= (currentYear - 5)) {
		age = 'new development';
	} else if((yrBuilt >= (currentYear - 20)) && (yrBuilt <= (currentYear - 5))) {
		age = 'recently built';
	} else if((yrBuilt >= 1600) && (yrBuilt <= 1945)) {
		age = 'pre-war';
	} else if(yrBuilt >= 1945) {
		age = 'post-war';
	} 

  return age;  
}

export const _trackPageView = (obj = false) => {
  // console.log('_trackPageView obj', obj);

  //Track page view
  if (obj.dataType && obj.dataType != "") {
    var trackCode = "track.";
    trackCode += obj.isListing
      ? "listing"
      : _nameToUrl(obj.dataType);

    let tabObj;
    if (obj.tabTags && obj.tabTags[0]) {
      tabObj = obj.tabTags[0];
    }

    if (tabObj && tabObj.key) {
      trackCode += "." + _nameToUrl(tabObj.key);
    }
    
    let data = {};
    switch (obj.dataType) {
      case "unit":
        data = {
          building:
            obj.buildingTags && obj.buildingTags[0]
              ? obj.buildingTags[0]
              : {},
          unit:
            obj.unitTags && obj.unitTags[0]
              ? obj.unitTags[0]
              : {}
        };
        break;
      case "building":
      case "building-info":
        data =
          obj.routeInfo
            ? obj.routeInfo
            : obj.buildingTags && obj.buildingTags[0]
              ? obj.buildingTags[0]
              : {}
        break;
      case "company":
        data =
          obj.companyTags && obj.companyTags[0]
            ? obj.companyTags[0]
            : {};
        break;
      case "person":
        data =
          obj.personTags && obj.personTags[0]
            ? obj.personTags[0]
            : {};
        break;
      default:
        break;
    }
      // console.log('trackCode', trackCode, 'data', data);
      Publisher.publish(trackCode, data);
    }
  }

